// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";global.Rails = Rails;
import { Turbo } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../application.css";

import jQuery from "jquery"
window.$ = window.jQuery = jQuery

Rails.start()
Turbo.start()
ActiveStorage.start()

import "controllers";
import "../stylesheets/application.scss";
